import type React from 'react';

import { Button, PaymentMethodIcon, PaymentMethodList, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

import { StripeCreditCardLayout } from 'src/app/shared/components/payments';

import { NameInputWrapper } from '../NameInputWrapper';
import { SubmitButton } from '../SubmitButton';

import { useStripeCreditCard } from './useStripeCreditCard';

export const StripeCreditCard: React.FC<Parameters<typeof useStripeCreditCard>[0]> = (props) => {
	const {
		data: { disabled, loading, ref, expanded, ...restData },
		actions: { handleExpandClick, ...restActions },
	} = useStripeCreditCard(props);

	return (
		<>
			<Button
				className={cn({ hidden: expanded })}
				variant="primary"
				size="small"
				onClick={handleExpandClick}
				data-qa="credit-card-form-expand-button"
			>
				<Translate value="corgi.co.promote.pay_with_credit_card" />
			</Button>
			<div className={cn('flex gap-3', { hidden: !expanded })} data-testid="form-wrapper">
				<div className="rounded-large elevation-elevated w-full p-5" data-qa="credit-card-form">
					<div className="flex items-center justify-between pb-4">
						<Text fontWeight="bold" ref={ref} tabIndex={-1}>
							<Translate value="corgi.co.promote.payment_type_button.card" />
						</Text>
						<PaymentMethodList>
							<PaymentMethodIcon type="visa" variant="card" />
							<PaymentMethodIcon type="mastercard" variant="card" />
							<PaymentMethodIcon type="discover" variant="card" />
							<PaymentMethodIcon type="americanexpress" variant="card" />
						</PaymentMethodList>
					</div>
					<StripeCreditCardLayout
						{...restData}
						{...restActions}
						layout="single"
						submitButton={<SubmitButton disabled={disabled} loading={loading} />}
						displayErrorInAlert
						disabled={loading}
					>
						<NameInputWrapper disabled={loading} paymentType="creditCard" />
					</StripeCreditCardLayout>
				</div>
			</div>
		</>
	);
};
